export default __webpack_public_path__ + "static/media/summary_planimages_84a.5392ec72.png";